import React from "react";
import ReactDOM from "react-dom";
import  "./Category.css";
const category =(props) =>{
    var accesskey=null;
    let items= props.items.map((item,index)=>{
        accesskey = item.MODFooterAccessKey ? {accessKey: item.MODFooterAccessKey} : null;
        return <div className="footerItem" key={"Category_"+index}><a href={item.MODFooterLink.NavigateUrl} {...accesskey} ><div>{item.LinkTitle}</div></a></div>
        
    });
    return (
         <li className=" col-6 col-md-3 ">
            <div className="categoryTitle ">{props.title}</div> 
            <div className="categoryBorderTitle"></div>
            <div>{items}</div>
        </li>
    )
}


export default category;